import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import CustomSelect from "../../components/CustomSelectInput";
import CustomButton from "../../components/CustomButton";
import useCustomStyles from "../../hooks/useCustomStyles";
import { customStyles } from "../../assets/styles/notificationForm";
import { selectTranslationState } from "../../store/slices/languageSlice";
import { selectState } from "../../store/slices/themeSlice";
import CustomInput from "../../components/CustomInput";
import { AppDispatch, RootState } from "../../store/store";
import {
  AccessCodeType,
  addAccessCode,
  ContractType,
  getContractsByBusinesses,
} from "../../store/actions/accessCodeActions";
import CustomMultiSelect from "../../components/CustomMultiSelect";
import validationSchema from "./scripts";
import { Option } from "../../components/CustomMultiSelect";
// import {
//   listenToLicenceCountUpdates,
//   listenToLicenceValidatedUpdates,
// } from "../../db/listners";
import { setContracts, setLicence } from "../../store/slices/accessCodeSlice";
import { useNavigate } from "react-router-dom";
import { addSevenDays, getCurrentDateFormatted } from "../../utils";

const GenerateLicences = () => {
  const { t } = useSelector(selectTranslationState);
  const { theme, activeTheme , textTheme} = useSelector(selectState);
  const { user } = useSelector((state: RootState) => state.auth_slice);
  const { contracts, loading, businesses } = useSelector(
    (state: RootState) => state.accessCode_slice
  );
  const classes = useCustomStyles(customStyles, theme);
  const [filteredContracts, setFilteredContracts] = useState(contracts);
  const [openLicenceCount, setOpenLicenceCount] = useState<number>(0);
  const [contractExpiry, setContractExpiry] = useState<
    string | Date | undefined
  >("");
  const isSopherAdmin =
    user?.business?.name === "sopher" || user?.business?.name === "sopher-test";
  const isOlympeAdmin =
    user?.business?.name == "OLYMPE" || user?.business?.name == "OLYMPE_TEST";

  const specialAdminCase = isSopherAdmin || isOlympeAdmin;

  const [roleTypeOptions, setRoleTypeOptions] = useState(
    specialAdminCase
      ? [
          { name: "Client", id: "client" },
          { name: "Advisor", id: "advisor" },
        ]
      : [{ name: "Client", id: "client" }]
  );

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  // useEffect(() => {
  //   // Define the function that updates the state (or dispatches a Redux action)
  //   const handleLicenseUpdate = (accessCode: AccessCodeType) => {
  //     // Example of dispatching a Redux action
  //     dispatch(setLicence(accessCode));
  //   };

  //   const updateContractsInState = (contracts: ContractType[]) => {
  //     // Dispatch an action to update the entire contracts list in the Redux store
  //     dispatch(setContracts(contracts)); // Ensure this action is set up in your Redux slice
  //   };
  //   // Start listening to licence validated updates
  //   const unsubscribeLicence =
  //     listenToLicenceValidatedUpdates(handleLicenseUpdate);

  //   // Start listening to licence count updates
  //   const unsubscribeContract = listenToLicenceCountUpdates(
  //     updateContractsInState
  //   );

  //   // Cleanup listener when the component unmounts
  //   return () => {
  //     if (unsubscribeLicence) {
  //       unsubscribeLicence(); // Unsubscribe from licence updates
  //     }
  //     if (unsubscribeContract) {
  //       unsubscribeContract(); // Unsubscribe from contract updates
  //     }
  //   };
  // }, []);

  const roleList = [
    //{label: 'Marketing', value: 'Marketing'},
    { label: "CRM", value: "CRM" },
    { label: "Administrator", value: "Administrator" },
  ];

  const formik = useFormik({
    initialValues: {
      roles: [],
      role_type: "client",
      codeType: "licence-code",
      contract_ref: "",
      contract_left_licences: 0,
      business_client: user?.business?.id || "",
      partner: "",
      email: "",
      expire_at: addSevenDays(getCurrentDateFormatted()),
      useLimit: 1,
      number_of_codes_to_generate: 1,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      await dispatch(
        addAccessCode({
          role_type: values.role_type,
          roles: values.roles,
          expire_at: contractExpiry?.toString(),
          codeType: values.codeType,
          contract_ref: values.contract_ref,
          business_client: values.business_client,
          number_of_codes_to_generate: values.number_of_codes_to_generate,
          navigate,
        })
      );
    },
    validateOnChange: false, // Disable validation on change
    validateOnBlur: false, // Disable validation on blur
  });

  const { values, setFieldValue, handleBlur, handleSubmit, setFieldTouched } =
    formik;

  useEffect(() => {
    if (!contracts) {
      if (user?.business?.name) {
        const isAdmin = user.roles.includes("master");
        let businessNames: string[];

        switch (user.business.name) {
          case "sopher":
            businessNames = isAdmin
              ? ["sopher", "SOPHER_ACCOUNTING"]
              : ["sopher"];
            break;

          case "sopher-test": {
            //  console.log('sopher-test business name from get clients',user.email, user.user_name ,user.business.name)
            businessNames = isAdmin
              ? ["sopher-test", "SOPHER_ACCOUNTING_TEST"]
              : ["sopher-test"];
            break;
          }

          default: {
            //   console.log('default business name from get clients',user.email, user.user_name ,user.business.name)
            businessNames = [user.business.name];
            break;
          }
        }

        //  console.log('businessNames from get dashboard before  getAccessCodes', businessNames)
        dispatch(getContractsByBusinesses({ business_names: businessNames }));
      }
    }
  }, []);

  useEffect(() => {
    // console.log(' fetch contracts for business', formik.values.business_client)
    if (contracts && user?.business) {
      const isAdmin = user.roles.includes("master");
      let businessNames: string[];

      switch (user.business.name) {
        case "sopher":
          businessNames = isAdmin
            ? ["sopher", "SOPHER_ACCOUNTING"]
            : ["sopher"];
          break;

        case "sopher-test": {
          //console.log('sopher-test business name from get clients',user.email, user.user_name ,user.business.name)
          businessNames = isAdmin
            ? ["sopher-test", "SOPHER_ACCOUNTING_TEST"]
            : ["sopher-test"];
          break;
        }

        default: {
          // console.log('default business name from get clients',user.email, user.user_name ,user.business.name)
          businessNames = [user.business.name];
          break;
        }
      }
      const business_ids: string[] = [];
      businesses?.forEach((business) => {
        if (businessNames.includes(business.name)) {
          business_ids.push(business.id);
        }
      });
      setFilteredContracts(
        contracts.filter(
          (item: ContractType) =>
            item.business_client &&
            business_ids.includes(item.business_client) &&
            item.useLimit - item.licence_count > 0 &&
            item.expire_at &&
            new Date(item.expire_at) > new Date()
        )
      );
    }
  }, [contracts]);

  // Wrapper function to handle form submission from button click
  const handleFormSubmit = async (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    await formik.submitForm();
  };

  const handleContractRefChange = async (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    await setFieldValue(name, value);
    await setFieldTouched(name, true);
    const valid = await validationSchema.validateAt(name, { [name]: value });
    if (valid) {
      formik.setFieldError(name, undefined); // Clear the error if validation passes
      const selectedContract = filteredContracts?.filter(
        (item) => item.id == e.target.value
      )[0];
      if (selectedContract) {
        // console.log("selectedContract:::::::::::::::::::::::::::::::::", selectedContract.business_client);
        const business = businesses?.find(
          (item) => item.id === selectedContract.business_client
        );
        if (
          business &&
          (business.name === "sopher" || business.name === "sopher-test")
        ) {
          setRoleTypeOptions([
            { name: "Client", id: "client" },
            { name: "Advisor", id: "advisor" },
          ]);
        } else {
          setRoleTypeOptions([{ name: "Client", id: "client" }]);
        }
        setOpenLicenceCount(
          selectedContract.useLimit - selectedContract.licence_count
        );
        setFieldValue(
          "contract_left_licences",
          selectedContract.useLimit - selectedContract.licence_count
        );
        setContractExpiry(selectedContract.expire_at);
        setFieldValue("expire_at", selectedContract.expire_at);
        // console.log('selectedContract.expire_at,  contract_left_licences', selectedContract.expire_at, selectedContract.useLimit - selectedContract.licence_count)
        try {
          await validationSchema.validateAt("contract_left_licences", {
            contract_left_licences:
              selectedContract.useLimit - selectedContract.licence_count,
            codeType: ["licence-code"], // make sure the dependency field is included!
          });
          formik.setFieldError("contract_left_licences", undefined);
        } catch (error) {
          if (error instanceof Error) {
            // Handle the error if validation fails
            console.error("Validation error:", error.message);
          }
          // console.log('contract_left_licences error', error)
          formik.setFieldError(
            "contract_left_licences",
            "All licences in the selected contract have been used. Please choose another contract."
          );
        }

        try {
          await validationSchema.validateAt("expire_at", {
            expire_at: selectedContract.expire_at
              ? new Date(selectedContract.expire_at)
              : "",
            codeType: ["licence-code"], // include this as well
          });
          formik.setFieldError("expire_at", undefined);
        } catch (error) {
          if (error instanceof Error) {
            // Handle the error if validation fails
            console.error("Validation error:", error.message);
          }
          formik.setFieldError(
            "expire_at",
            "The selected contract has expired. Please choose another contract."
          );
        }

        setFieldValue("business_client", selectedContract.business_client);

        // console.log('contract expiry date', selectedContract.expire_at)
        // const validExpiry = await validationSchema.validateAt('expire_at', { ['expire_at']: selectedContract.expire_at? new Date(selectedContract.expire_at): '' , codeType: ['licence-code']});
        // console.log('contract expiry date validation', selectedContract.expire_at, validExpiry)

        // if (validExpiry) {
        //   formik.setFieldError("expire_at", undefined); // Clear the error if validation passes
        // } else {
        //   formik.setFieldError(
        //     "expire_at",
        //     "All licences in the selected contract have expired. Please choose another contract."
        //   );
        // }
      }
    }
  };

  const handleSelectFieldChange1 = async (
    e:
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = e.target;
    if (name == "business_client") {
      await setFieldValue("contract_ref", "");
      setOpenLicenceCount(0);
      setFieldValue("contract_left_licences", 0);
    }
    await setFieldValue(name, value);
    await setFieldTouched(name, true);
    if (name == "role_type" && value == "client") {
      await setFieldValue("roles", []);
    }

    const valid = await formik.validateForm();
    if (valid) {
      // console.log("field validated", name, value);
    } else {
      // console.log("field not validated", name, formik.errors);
    }
  };

  const handleSelectFieldChange2 = async (e: {
    name: string;
    value: string | number | Option[];
  }) => {
    const { name, value } = e;
    await setFieldValue(name, value);
    await setFieldTouched(name, true);
    const valid = await formik.validateForm();
    if (valid) {
      // console.log("field validated", name, value);
    } else {
      // console.log("field not validated", name, formik.errors);
    }
  };

  //useEffect(() => {
  // console.log("formik values / errors", formik.errors, formik.values);
  // }, [formik.errors, formik.values]);

  return (
    <div className={classes?.container}>
      <div className={classes?.notificationForm}>
        <h1 className={classes?.title}>
          {t[textTheme].generateLicencesScreen.form.title}
        </h1>
        <hr className={classes?.divider} />

        <form onSubmit={handleSubmit} className={classes?.notificationForm}>
          <CustomSelect
            label={
              t[textTheme].generateLicencesScreen.form.contractRefInput.label
            }
            name="contract_ref"
            value={values.contract_ref}
            options={
              filteredContracts
                ? filteredContracts
                    .filter((item) => item.contract_ref && item.id)
                    .map((item) => ({
                      name: item.contract_ref as string,
                      id: item.id as string,
                    }))
                : []
            }
            onChange={async (e) => await handleContractRefChange(e)}
            onBlure={handleBlur}
            placeholder={
              t[textTheme].generateLicencesScreen.form.contractRefInput
                .placeholder
            }
            error={formik.errors.contract_ref ? formik.errors.contract_ref : ""}
          />

          {values.contract_ref && (
            <>
              <CustomInput
                label={
                  t[textTheme].generateLicencesScreen.form
                    .remainingLicencesInput.label
                }
                name="contract_left_licences"
                type="number"
                value={openLicenceCount}
                onChange={async (e) => await handleSelectFieldChange1(e)}
                disabled
                error={
                  formik.errors.contract_left_licences
                    ? formik.errors.contract_left_licences
                    : ""
                }
              />

              <CustomInput
                label={
                  t[textTheme].generateLicencesScreen.form
                    .subscriptionExpiryInput.label
                }
                name="contract_expiry_date"
                type="text"
                value={contractExpiry}
                onChange={() => {
                  return;
                }}
                disabled
                error={formik.errors.expire_at ? formik.errors.expire_at : ""}
              />

              <CustomSelect
                label={
                  t[textTheme].generateLicencesScreen.form.roleTypeInput.label
                }
                name="role_type"
                value={values.role_type}
                options={roleTypeOptions}
                onChange={async (e) => await handleSelectFieldChange1(e)}
                placeholder={
                  t[textTheme].generateLicencesScreen.form.roleTypeInput
                    .placeholder
                }
                onBlure={handleBlur}
                error={
                  formik.errors.role_type && formik.touched.role_type
                    ? formik.errors.role_type
                    : ""
                }
              />

              {values.role_type === "advisor" && (
                <CustomMultiSelect
                  name="roles"
                  value={values.roles}
                  onChange={(value) =>
                    handleSelectFieldChange2({ name: "roles", value })
                  }
                  options={roleList}
                  label={
                    t[textTheme].generateLicencesScreen.form.rolesInput.label
                  }
                  error={
                    Array.isArray(formik.errors.roles)
                      ? formik.errors.roles.join(", ") // Combine all error messages into a single string
                      : formik.errors.roles || ""
                  }
                />
              )}

          
            </>
          )}

          <CustomButton
            title={
              t[textTheme].generateLicencesScreen.form.generateButton.title
            }
            name="generateAccessCode"
            handleClick={handleFormSubmit}
            type="submit"
            loading={loading}
            disabled={!formik.isValid || loading || !formik.dirty}
          />
        </form>
      </div>
    </div>
  );
};

export default GenerateLicences;
